import {optionAction} from "../../redux/store";
import {useDispatch, useSelector} from "react-redux";

export const useExteriorTone = () => {
  const dispatch = useDispatch();

  const configData = useSelector(state => state.optionWindow.CONFIG_DATA);

  const handleToneToggle = (toneCode) => {

    if (toneCode === "SINGLE_TONE") {
      dispatch(optionAction.setSendDataRemove("EXT_SPECIAL"))
    } else if (toneCode === "DUAL_TONE") {
      dispatch(optionAction.setSendData({
        key: "EXT_SPECIAL",
        value: configData["EXT_MAIN"] || ""
      }));

    }
  };
  return {
    handleToneToggle
  };
};
